module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1013-3e11cdd6a6236c434f7a499850311b81.png";